import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import type { ReactElement } from 'react';
import { CollectionsPageLayout } from '@members/pg-collections/CollectionsPageLayout';

const CollectionDetails = dynamic(
  () => import('@members/pg-collections/CollectionPage'),
  {
    ssr: false,
  },
);

export default function CollectionDetailsPage() {
  const router = useRouter();
  return <CollectionDetails collectionId={router.query.collectionId as string} />;
}

CollectionDetailsPage.getLayout = function getLayout(page: ReactElement) {
  return <CollectionsPageLayout>{page}</CollectionsPageLayout>;
};
